// extracted by mini-css-extract-plugin
module.exports = {"image-icon":"b49a62dc46--image-icon--SrnfS","crm-icon":"b49a62dc46--crm-icon--IiGhg","button":"b49a62dc46--button--Ht5W7","button-tablet":"b49a62dc46--button-tablet--i6Mhm"};